import React from 'react'
import disabledRadio from '../images/disabledRadio.svg'
import enabledRadio from '../images/enabledRadio.svg'

class StandardButtonWithRadioComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        {this.props.enabledRadio
          ? <button
            onClick={this.props.onClick}
            style={styles.button}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <img
                      style={styles.icon}
                      src={enabledRadio}
                      alt='true'
                    />
                  </td>
                  <td>
                    <span style={styles.label}>{this.props.label}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </button>
          : <button
            onClick={this.props.onClick}
            style={styles.button}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <img
                      style={styles.icon}
                      src={disabledRadio}
                      alt='true'
                    />
                  </td>
                  <td>
                    <span style={styles.label}>{this.props.label}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </button>
        }
      </div>
    )
  }
}

const styles = {
  buttonContent: {
    marginTop: '8px',
    float: 'left',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: 'auto',
    height: '36px',
    marginLeft: '12px',
    borderWidth: '0px',
    borderRadius: '22px',
    backgroundColor: '#2C343A',
    outline: 'none'
  },
  label: {
    textAlign: 'center',
    color: '#A6B9C8',
    fontSize: '12px',
    marginLeft: '8px',
    marginRight: '8px',
    fontWeight: 500
  },
  icon: {
    float: 'left'
  }
}

export default StandardButtonWithRadioComponent
